import { useState, useRef, useEffect } from "react";

export default function ServiceDetailStyle() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-style">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <h4>Style & Mood</h4>
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Design</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <h4 className="heading">Precision and detail, for sophisticated interiors</h4>
                </div>

                <div className="col-lg-6 col-md-6">
                    <p>Intricate wood paneling, custom cabinetry, and elegant joinery meet contemporary and classic design sensibilities. Saysha Interiors’ woodwork brings a tactile richness and depth to every space, balancing artisanal craftsmanship with modern sophistication to create interiors that feel luxurious, warm, and timeless.</p>
                </div>

            </div>
        </div>
    </section>             
    </>
  )
}
